import React from "react";
import { $t } from '@/modules/i18n';

const Contact = ({ message = {} }) => (
  <section id="contact" >
    { message.title && <h2 className="section-title">{$t(message.title)}</h2> }
    <div className="content">
    {
      (message.desc || []).map(desc => <p dangerouslySetInnerHTML={{ __html: $t(desc) }} key={desc} /> )
    }
    {
      message.btn ? <a href={message.btnLink} className="btn" target="_blank" rel="noopener noreferrer">{$t(message.btn)}</a> : null
    }
    </div>
  </section>
);

export default Contact;
